import { createReducer } from '@reduxjs/toolkit';
import {
  addUpsellCartItem,
  removeUpsell,
  setAllUpsellData,
  setUpsellAmount,
} from './action';
import type { UpsellState } from './state';
import initialUpsellState from './state';

const upsellReducer = createReducer<UpsellState>(
  initialUpsellState,
  (builder) => {
    builder.addCase(
      addUpsellCartItem,
      (state, { payload: { amount, parentCartItemId, productId } }) => {
        const availableUpsells = state.groups[parentCartItemId];

        if (!availableUpsells) {
          return state;
        }

        const upsells = availableUpsells.map((group) => ({
          ...group,
          products: group.products.map((upsellProduct) => {
            if (upsellProduct.id === productId) {
              return {
                ...upsellProduct,
                amountInCart: amount ?? 1,
                inCart: true,
              };
            }
            return upsellProduct;
          }),
        }));

        return {
          ...state,
          groups: {
            ...state.groups,
            [parentCartItemId]: upsells,
          },
        };
      },
    );
    builder.addCase(setAllUpsellData, (state, { payload: upsellState }) => ({
      ...state,
      ...upsellState,
    }));
    builder.addCase(
      setUpsellAmount,
      (state, { payload: { amount, id, parentCartItemId } }) => {
        const upsellGroups = state.groups[parentCartItemId];

        if (!upsellGroups) {
          return state;
        }

        const upsells = upsellGroups.map((group) => ({
          ...group,
          products: group.products.map((upsellProduct) => {
            if (
              upsellProduct.cartItemId === id &&
              upsellProduct.amountMutable
            ) {
              return {
                ...upsellProduct,
                amountInCart: Math.max(1, amount),
              };
            }
            return upsellProduct;
          }),
        }));

        return {
          ...state,
          groups: {
            ...state.groups,
            [parentCartItemId]: upsells,
          },
        };
      },
    );
    builder.addCase(
      removeUpsell,
      (state, { payload: { id, parentCartItemId } }) => {
        const availableUpsellGroupsForCartItem =
          state.groups[parentCartItemId] ?? [];

        return {
          ...state,
          groups: {
            ...state.groups,
            [parentCartItemId]: availableUpsellGroupsForCartItem.map(
              (group) => ({
                ...group,
                products: group.products.map((upsellProduct) => {
                  if (upsellProduct.cartItemId === id) {
                    return {
                      ...upsellProduct,
                      amountInCart: 0,
                      cartItemId: '0',
                      inCart: false,
                    };
                  }
                  return upsellProduct;
                }),
              }),
            ),
          },
        };
      },
    );
  },
);

export default upsellReducer;
